import { View } from '@Engage.Data/modules/view';
import { UserStore } from '../../auth/model/UserStore';
export class VariableReplacer {
    /**
     * Replace all {{variable}} placeholders and evaluate inline functions.
     * Mirrors Connext v2 dom.parseVariables() which does both steps.
     * Returns the processed HTML.
     */
    static process(html) {
        if (!html)
            return html;
        const variables = this.buildVariables();
        // Save scripts separately so we don't evaluate functions inside them
        const scripts = [];
        html = html.replace(/<script[\s\S]*?<\/script>/gi, (match) => {
            scripts.push(match);
            return `__SCRIPT_PLACEHOLDER_${scripts.length - 1}__`;
        });
        // Step 1: Replace {{variable}} placeholders
        if (html.includes('{{')) {
            html = html.replace(/\{\{(\w+)\}\}/g, (match, key) => {
                var _a;
                return variables.hasOwnProperty(key) ? ((_a = variables[key]) !== null && _a !== void 0 ? _a : '') : '';
            });
        }
        // Step 2: Evaluate inline functions (outside <script> tags)
        // Matches: function(...) { ... } and (...) => { ... } or (...) => expr
        const funcRegex = /(?:function\s*\([\w\s,]*\)\s*\{[\s\S]*?\})|(?:\([\w\s,]*\)\s*=>\s*(?:\{[\s\S]*?\}|[^;]+))/g;
        html = html.replace(funcRegex, (match) => {
            try {
                const fn = new Function(`return ${match}`)();
                const result = typeof fn === 'function' ? fn() : fn;
                return result != null ? result.toString() : '';
            }
            catch (_a) {
                return '';
            }
        });
        // Restore scripts
        html = html.replace(/__SCRIPT_PLACEHOLDER_(\d+)__/g, (_, idx) => scripts[+idx]);
        return html;
    }
    /**
     * Builds the variables object from all available sources.\
     */
    static buildVariables() {
        const vars = {};
        // ─── View-based variables ─────────────────────────────────────────
        try {
            const currentViewCount = View.getCurrentConversationViewCount() || 0;
            const totalViews = View.getTotalArticleCount() || 0;
            const freeArticleRemaining = View.isFreeArticleAvailable() || 0;
            vars['CurrentViewCount'] = String(currentViewCount);
            vars['FreeViewsLeft'] = String(freeArticleRemaining);
            vars['ArticleLeft'] = String(freeArticleRemaining); // alias
            vars['TotalViews'] = String(totalViews);
        }
        catch ( /* View not initialized */_a) { /* View not initialized */ }
        // ─── User-based variables ─────────────────────────────────────────
        try {
            const user = UserStore.getUser();
            if (user) {
                vars['UserFullName'] = user.FullName || user.DisplayName || '';
                vars['DisplayName'] = user.DisplayName || user.FullName || '';
                vars['UserEmail'] = user.Email || '';
            }
        }
        catch ( /* no user */_b) { /* no user */ }
        // ─── Placeholder for variables not yet available in SDK ────────────
        // ExpireTimeLeft and ArticleCost require campaign/conversation data
        // that isn't exposed yet. They'll resolve to empty string.
        vars['ExpireTimeLeft'] = '';
        vars['ArticleCost'] = '';
        return vars;
    }
}
